function State(params) {
    return {
        type: "APPOINTMENT_CABINET",
        cabinetId: params.cabinetId,
        cabinetIndex: params.cabinetIndex
    }
}

export function GetCabinet(params) {
    return (dispatch) => {
        return dispatch(State(params))
    }
}



// WEBPACK FOOTER //
// frontend/src/actions/GetCabinet.js